/**
 * These endpoints should be all relative to Vignette origin URL, i.e:
 *   - http://localhost:8080/ => redirects will be broken in most cases
 *   - http://localhost:8001/vignette/
 *   - https://dev.njdc.com/vignette/
 *   - https://www.nationaljournal.com/vignette/
 */
/* eslint typescript-sort-keys/string-enum: "error" */
import { FilterEnumByPrefix } from "@/types/utils/GenericUtilityTypes";

export enum VignetteEndpoints {
  API_ADD_ALL_SEARCH_RESULTS = "api/briefcase/addAllSearchResults/",
  API_AGENCY = "api/agency/",
  API_AGENCY_EXPORT = "api/agencyExport/",
  API_APP_CONFIG = "api/config/app/",
  API_BRIEFCASE = "api/briefcase/",
  API_BRIEFCASE_DOWNLOAD_CHECK = "api/folderDossierDownloadCheck/",
  API_BRIEFCASE_FOLDER_ADD = "api/briefcase/folder/add",
  API_BRIEFCASE_FOLDER_DELETE = "api/briefcase/folder/delete",
  API_BRIEFCASE_TOGGLE = "api/briefcase/toggle/",
  API_BULK_DOSSIER_DOWNLOAD = "api/bulkDossierDownload/",
  API_BULK_DOSSIER_DOWNLOAD_CHECK = "api/bulkDossierDownloadCheck/",
  API_CAUCUS = "api/caucus/",
  API_CAUCUS_EXPORT = "api/caucusExport/",
  API_COMMITTEE = "api/committee/",
  API_COMMITTEE_EXPORT = "api/committeeExport/",
  API_DISTRICT = "api/district/",
  API_HOMEPAGE_CONFIG = "api/config/homepage/",
  API_JOB_TITLE_SUGGEST_KW = "api/jobTitleSuggestKnowWho/",
  API_PROFILE = "api/profile/",
  API_PROFILE_KW = "api/profileKnowWho/",
  API_PROFILE_KW_EXPORT = "api/profileKnowWhoExport/",
  API_REQUEST_CUSTOM_LOGO = "api/requestCustomLogo/",
  API_SEARCH_CONGRESSIONAL = "api/search/congressional/",
  API_SEARCH_CONGRESSIONAL_EXPORT = "api/searchExport/congressional/",
  API_SEARCH_FEDERAL = "api/search/federal/",
  API_SEARCH_FEDERAL_EXPORT = "api/searchExport/federal/",
  API_SEARCH_STATE = "api/search/state/",
  API_SEARCH_STATE_EXPORT = "api/searchExport/state/",
  API_SEARCH_VIGNETTE = "api/search/vignette/",
  API_SEARCH_VIGNETTE_EXPORT = "api/searchExport/",
  API_SESSION = "api/session/",
  API_STATE = "api/state/",
  LOGOUT = "logout/",
}

export type SearchEndpoints = FilterEnumByPrefix<
  typeof VignetteEndpoints,
  "api/search/"
>;
